export const TOKEN_COOKIE_NAME = 'auth_token';
export const USER_LOGGED_KEY_NAME = 'isLogged';
export const DOC_LINKS_KEY_NAME = 'docsLinks';
export const REFRESH_TOKEN_NAME = 'refresh_token';
